import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { OL_COLOUR_BLACK_90 } from '../Style/colours';
import { AlertMessageTheme } from './types';

export const AlertMessageBox = styled('div')<{
  theme: AlertMessageTheme;
  inContent: boolean;
}>(({ theme, inContent }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',

  background: theme.background,
  padding: inContent ? 20 : 19,
  borderWidth: inContent ? 0 : 1,
  borderStyle: 'solid',
  borderColor: theme.borderColor,
  borderRadius: 8,
}));

export const IconColumn = styled('div')({
  width: 21, // make sure the icon column width is fixed
  marginRight: 10,
  marginTop: 2,
});

export const TextColumn = styled('div')({
  marginTop: 0,
});

export const StyledIcon = styled(FontAwesomeIcon)<{ theme: AlertMessageTheme }>(
  ({ theme }) => ({
    fontSize: 18,
    color: theme.iconColor,
  })
);

// Normally we use h1/h2/h3/h4 for header, but it would risk breaking
// the HTML hierarchy since every page would have slightly different
// structure, so using div just to be safe.
export const Header = styled('div')({
  fontSize: 14,
  fontWeight: 600,
  lineHeight: 1.5,
  color: OL_COLOUR_BLACK_90,
});

export const Content = styled('div')<{ hasHeader?: boolean }>(
  ({ hasHeader }) => ({
    fontSize: 14,
    lineHeight: 1.5,
    color: OL_COLOUR_BLACK_90,
    marginTop: hasHeader ? 5 : 0,

    p: {
      marginTop: 0,
      marginBottom: 5,
      fontSize: 'inherit',
      lineHeight: 'inherit',

      '&:last-of-type': {
        marginBottom: 0,
      },
    },

    a: {
      textDecoration: 'underline',
    },
  })
);
